module.exports = __webpack_public_path__ + "assets/images/project/jordan.jpg?v=f5057fb6";